import script from "./ProfileActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileActivity.vue?vue&type=script&setup=true&lang=js"

import "./ProfileActivity.vue?vue&type=style&index=0&id=07b599fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b599fb"]])

export default __exports__